import { Table } from "../../../../components/CustomPaginations";
import React, { useContext, useEffect, useState } from "react";
import { UserConsumer, UserContext } from "../../../../UserContext";
import Header from "../../../../components/Header";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { tableStyle } from "../../../../components/TableStyle";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import axios from "axios";
import moment from "moment";
import { Routes } from "../../../../configurations/config";

function VendorCategories() {
	const history = useHistory();
	const { token } = useContext(UserContext);
	const [vendorCategories, setVendorCategories] = useState([]);
	const { vendorId } = useParams();

	useEffect(() => {
		axios
			.get(`${ItemRequisitionAPI.GetItemRequisitionVendor}/${vendorId}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				setVendorCategories(
					res.data.categories.map((item) => {
						return {
							name: item.label,
							details: item.description,
							status: res.data.approved
								? "Approved"
								: "Not Approved",
							validUpto: moment(res.data.validUpTo).format(
								"DD MMM YYYY "
							),
						};
					})
				);
			});
	}, []);

	const getColumns = [
		{
			dataField: "name",
			text: "Name",
		},
		{
			dataField: "details",
			text: "Detail",
		},
		{
			dataField: "status",
			text: "Status",
		},
		{
			dataField: "validUpto",
			text: "Valid Upto",
			formatter: (cell, row) => {
				return (
					<span>
						{row.validUpto === "Invalid date"
							? "No date avaliable"
							: row.validUpto}
					</span>
				);
			},
		},
	];
	return (
		<UserConsumer>
			{(userDetails) => {
				return userDetails.id.toString() === "40" ||
					userDetails.id.toString() === "33" ||
					userDetails.empRole.includes("3") ? (
					<>
						<div className="container-fluid pl-3 pr-3 pt-3">
							<Header
								title="Vendor Categories"
								headerBorder="true"
								navigateBack={() =>
									history.push(Routes.ItemRequisitionVendors)
								}
							/>
							<Table
								inputValue={""}
								keyField={"name"}
								columns={getColumns}
								items={vendorCategories}
								tableStyle={tableStyle}
								showFeedback={false}
								SearchBar={() => {
									return null;
								}}
							/>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default VendorCategories;
